<template>
  <div class="mb-3">
    <text-input v-model="form.name" :error="form.errors.name" label="Name" />
    <div class="mb-3">
      <label for="">Code:</label>
      <div>{{ form.code }}</div>
    </div>
    <div class="mb-3">
      <label for="">Group:</label>
      <div>{{ form.group }}</div>
    </div>
    <div class="mb-3">
      <label for="">Available tags:</label>
      <div class="tags">
        <span class="tag" v-for="(tag, index) in tags" :key="index">{{ tag }}</span>
      </div>
    </div>
    <editor
        api-key="wk0iduiwkjwjr9x9gm8yfkr7v8y5ltp7xab2qkdhgoupdzdd"
        v-model="form.html_template"
        :init="{
          height: 300,
          menubar: false,
          plugins: ['lists', 'link', 'code'],
          toolbar:
            'undo redo | styles | forecolor | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link code'
        }"
      />
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import Editor from '@tinymce/tinymce-vue'

export default {
  name: 'MailTemplateForm',
  data() {
    return {
      tags: [
        '{{ agency_name }}',
        '{{ agent_firstname }}',
        '{{ agent_lastname }}',
        '{{ customer_company }}',
        '{{ customer_title }}',
        '{{ customer_firstname }}',
        '{{ customer_middlename }}',
        '{{ customer_lastname }}',
        '{{ booking_number }}',
        '{{ ticket_count }}',
        '{{ passengers }}',
        '{{ operator }}',
        '{{ journeys }}',
        '{{ itinerary }}',
        '{{ cost_overview }}',
        '{{ grand_total }}',
        '{{ payment_url }}'
      ]
    }
  },
  components: {
    TextInput,
    TextareaInput,
    Editor
  },
  props: {
    form: Object
  }
}
</script>

<style lang="scss">
.tags {
  .tag {
    display: inline-block;
    padding: 0.225rem 0.5rem;
    font-size: 0.875rem;
    background: var(--bs-gray-200);
    margin-bottom: 0.25rem;
    margin-right: 0.25rem;
    border-radius: 3px;
  }
}
</style>
